var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticStyle:{"background-color":"rgb(245, 245, 249) !important"},attrs:{"padless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"lighten-2 py-4 text-center",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" E3Mobility inc. All rights reserved. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }